var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: { color: "secondary", cancel: true, "prevent-close": "" },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function(props) {
            return [
              _c("q-btn", {
                attrs: { label: _vm.$t("cancel"), flat: "" },
                on: {
                  click: function($event) {
                    _vm.handleCancel(props.cancel)
                  }
                }
              }),
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("ok"),
                  disabled: !_vm.hasDiscount,
                  flat: ""
                },
                on: {
                  click: function($event) {
                    _vm.handleAdd(props.ok)
                  }
                }
              })
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialogModel,
        callback: function($$v) {
          _vm.dialogModel = $$v
        },
        expression: "dialogModel"
      }
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("discount_dialog_header")))
      ]),
      _c("span", {
        attrs: { slot: "message" },
        domProps: { innerHTML: _vm._s(_vm.$t("discount_dialog_content")) },
        slot: "message"
      }),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _c("discount-input", {
            attrs: {
              currency: _vm.currency,
              "discount-absolute": _vm.discount.abs,
              "discount-relative": _vm.discount.rel
            },
            on: {
              inputDiscountAbsolute: function($event) {
                _vm.discount.abs = $event
              },
              inputDiscountRelative: function($event) {
                _vm.discount.rel = $event
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }